<template>
  
  <div ref="profiles_overflow" class="scroller px-sm-5 px-lg-4 px-lg-1 pr-lg-5" >
        <button aria-hidden="true" class="btn-reset btn-close" v-on:click="close">
            <SVGClose role="button"></SVGClose>
            <span class="sr-only">Close</span>
        </button>
        
        <div ref="profile_detail" v-for="i in items" :key="i.id" :id="'profile_' + i.id" :data-id="i.id">
            <div class="m-lg-5">
                <div class="row justify-content-start pt-5 pt-lg-0 pl-2">
                    <div class="col">
                        <div class="rotate w-50">
                            <h2 class="mb-4 profile-header" tabindex="-1">
                                <span class="highlight guide-text mb-4">{{ $t(iKey('profiles_section', 'profile_labels', 'profile_label'))}}</span> <br> 
                                {{ i.first_name }}
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m-3 m-md-5">
                <div class="row">
                    <div class="col d-flex">
                        <figure class="img-profile" >
                            <img class="img-fluid" v-if="i.profile_image" v-lazy="i.profile_image.url_resized_square" :alt="$t(iKey('related_upstander_profiles', i, 'profile_image_desc'))">
                            <figcaption class="guide-text col-6 col-sm-8">
                                {{ $t(iKey('profiles_section', 'profile_labels', 'stands_for'))}} <br> 
                                {{ $t(iKey('related_upstander_profiles', i, 'issue')) }}
                            </figcaption>
                         </figure>
                        <img aria-hidden="true" v-if="i.texture_image" class="align-self-center img-texture" v-lazy="i.texture_image.url_resized_fit" >
                    </div>
                    
                </div>
            </div>
            <div class="m-3 m-md-5">
                <div class="row">
                    <div class="col-5 col-sm-6 d-flex">
                        <span aria-hidden="true" class="giant align-self-end" v-html="firstLetter(i.first_name)"></span>
                    </div>
                    <div class="col-7 col-sm-6 quote-wrap mb-5">
                        <QuoteHeader :bgColor="'#' + i.hex_code"></QuoteHeader>
                        <blockquote class="secondary">
                            {{ $t(iKey('related_upstander_profiles', i, 'pull_quote')) }}
                            <footer>&mdash; {{ i.full_name }}</footer>
                        </blockquote>
                    </div>
                </div>

                <div v-html="$t(iKey('related_upstander_profiles', i, 'paragraph_1'))"></div>
                
                <div v-if="i.video_url_en" class="vid-wrap position-relative">
                    <div class="vid-bg position-absolute" :style="{backgroundColor: '#' + i.hex_code, marginBottom: '6em'}"></div>
                    <div>
                        <VideoEmbed
                            ref="vid_embed"
                            class="vid-tilt"
                            :video_regular="$t(iKey('related_upstander_profiles', i, 'video_embed'))"
                            :video_descr="$t(iKey('related_upstander_profiles', i, 'video_desc_embed'))">
                        </VideoEmbed>
                    </div>
                </div>
                <div v-else-if="i.secondary_image" class="poster-wrap position-relative mb-5 d-flex justify-content-end">
                    <div class="poster-bg" :style="{backgroundColor: '#' + i.hex_code, marginBottom: '6em'}"></div>
                    <figure class="position-absolute">
                        <img class="img-fluid" v-lazy="i.secondary_image.url_resized_16x9" :alt="$t(iKey('related_upstander_profiles', i, 'secondary_image_desc'))">
                        <figcaption class="text-right">
                            {{ $t(iKey('related_upstander_profiles', i, 'secondary_image_caption')) }}
                        </figcaption>
                    </figure>
                </div>
                <div v-html="$t(iKey('related_upstander_profiles', i, 'paragraph_2'))"></div>
                <hr class="mt-5">
            </div>
            
        </div>

        <div class="m-5">
        <button aria-hidden="true" class="btn-reset d-none d-lg-inline" v-on:click="close">
            <SVGArrow role="button" class="btn-close-arrow"></SVGArrow>
            <span class="guide-text pl-3 align-top">{{ $t(iKey('ui_labels', 'ui', 'back')) }}</span>
        </button>
        </div>

    </div>
  
</template>

<script>
import { TweenLite } from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import ScrollMagic from 'scrollmagic';
ScrollToPlugin; // needed so ScrollToPlugin gets regsitered w webpack.

import SVGClose from "@/assets/icons/close.svg";
import SVGArrow from "@/assets/icons/arrow-skinny.svg"
import QuoteHeader from "@/components/ui/QuoteHeader";
import VideoEmbed from "@/components/ui/VideoEmbed";

export default {
  name: 'ProfileDetails',
  components: {
      SVGClose,
      SVGArrow,
      QuoteHeader,
      VideoEmbed
  },
  props: [
    'items',
    'profileId',
    'profilesOpen'
  ],
  watch: {
      profileId: function(newId){
        var container = this.$refs.profiles_overflow
        var profile = '#profile_' + newId
        
        TweenLite.to(container, 1, {scrollTo: profile, onComplete:() => {
            if(this.profilesOpen){ // accessibility focus
                document.getElementById('profile_' + newId).getElementsByClassName('profile-header')[0].focus();
            }
        }})
      },
      items: function(){
        this.$nextTick(() => {
            let controller = new ScrollMagic.Controller({container: this.$refs.profiles_overflow});
            this.$refs.profile_detail.forEach((profile) => {
                let trigger = profile;
                
                new ScrollMagic.Scene({
                    triggerElement: trigger,
                    duration: '100%'
                })
                .on('enter', (e) => {
                    let id = e.target.triggerElement().dataset.id
                    this.$emit('scrolledToProfile', id)
                })
                .on('leave', () => {
                    this.stopVideoPlayback();
                })
                .addTo(controller)
            })
        })
      }
  },
  methods: {
    close: function(){
        this.$emit('closeProfileDetails')
    },
    stopVideoPlayback(){
        let embeds = this.$refs.vid_embed
        if(embeds){
            embeds.forEach((videoPlayer) => {
                videoPlayer.stop();
            })
        }
    },
    firstLetter(name){
        if(name){
            return name.charAt(0);
        } else {
            return ""
        } 
    }
  },
  mounted(){
       
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.scroller {
    background-color: white;
    
    color: black;
}
@media (min-width: 992px) {
    .scroller {
        height: 100vh;
        width: 45%;
        position: fixed;
        left: 100%;
        top: 0;
        color: black;
        overflow-y: auto;
        transition: all 0.35s ease-out;
    }
}
#profiles_wrapper.open .scroller {
    left: 45%;
}
@media (min-width: 992px) {
    #profiles_wrapper.open .scroller {
        left: 55%;
    }
}

.rotate {
    transform: rotate(-3deg);
    margin-left: 20px;
}
@media (min-width: 576px) {
    .rotate {
        margin-left: -20px;
    }
}
.btn-close {
    position: fixed;
    right: 30px;
    top: 30px;
    opacity: 0;
    transition: opacity 0.2s;
    height: 60px;
    width: 60px;
    z-index: 2;
}

#profiles_wrapper.open .btn-close {
    opacity: 1.0;
}

.btn-close-arrow {
    transform: rotate(180deg);
    width: 28px;
}

span.highlight {
    display: inline-block;
    background-color: #ffd93d;
    padding: 4px 15px;
    white-space: nowrap;
}
@media (min-width: 992px) {
    span.highlight {
        padding: 4px 15px;
    }
}


.img-profile {
    width: 75%;
    position: relative;
    z-index: 1;
}
.img-texture {
    width: 25%;
    position: relative;
    margin-left: -5%;
}
.quote-wrap {
    margin-top: -180px;
    z-index: 1;
}
.giant {
    font-size: 120px;
    color: #382e2b;
    margin-bottom: -35px;
    display: inline-block;
}
@media (min-width: 992px) {
    .giant {
        font-size: 200px;
        margin-bottom: -70px;
        margin-left: -10px;
    }
}

.poster-bg,
.vid-bg {
    height: 0;
    padding-top: calc(56.25% * 0.9);
    width: 90%;
}
.poster-wrap img {
    transform: rotate(-4deg);
    width: 90%;
    margin-top: 40px;
}
.poster-wrap figure {
    top: 0;
    left: 0;
}

.vid-wrap {
    margin-bottom: 80px;
}
.vid-bg {
    width: 100%;
}
.vid-wrap .vid-tilt {
    right: 20px;
    position: relative;
    top: 30px;
    transform: rotate(-4deg);
}

hr {
    background-color: #382e2b; 
    height: 1px; 
    border: 0; 
}

</style>
